<template>
  <div class="mapArea_section">
    <div class="container">
      <div class="row">
        <div class="col-md-8">
          <div class="map_google">
            <div class="google-map">
              <GmapMap
                ref="mapss"
                :center="center"
                :zoom="17"
              
              >
                <GmapMarker :position="center" :draggable="false" />
              </GmapMap>
              <!--  :icon="get_setting_app.web_setting.map_icon" -->
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="contact_info">
            <div class="box_ta" v-if="get_contact_info.info">
              <h1>TA KONTAKT</h1>
              <a href="#" v-if="get_contact_info.info.contact_location.address !=''">
                <span class="icon"><i class="bx bxs-map"></i></span>
                <span class="text">{{get_contact_info.info.contact_location.address}}</span>
              </a>
              <a v-if="get_contact_info.info.contact_data.phone !=''" :href="`tel:${get_contact_info.info.contact_data.countryCode}${get_contact_info.info.contact_data.phone}`">
                <span class="icon"><i class="bx bxs-phone"></i></span>
                <span class="text">{{get_contact_info.info.contact_data.countryCode}}{{get_contact_info.info.contact_data.phone}}</span>
              </a>
              <a v-if="get_contact_info.info.contact_data.email !=''" :href="`mailto:${get_contact_info.info.contact_data.email}`">
                <span class="icon"><i class="bx bxs-envelope"></i></span>
                <span class="text">{{get_contact_info.info.contact_data.email}}</span>
              </a>
            </div>
            <div class="social_ta" v-if="get_contact_info.info">
              <template v-for="social in get_contact_info.info.contact_categories">
                 <a :key="social.id"
              :href="social.value"
              target="_black"
              v-show="social.value != ''"
              class="face"
              >
              <i :class="social.icon"></i>
              </a>
              </template>

            
              <!-- <a href="#"><i class="bx bxl-facebook"></i></a>
              <a href="#"><i class="bx bxl-instagram-alt"></i></a>
              <a href="#"><i class="bx bxl-whatsapp"></i></a>
              <a href="#"><i class="bx bxl-tiktok"></i></a> -->
            </div>
            <div class="open_ta" v-if="get_contact_info.info">
              <h2>ÅPNINGSTIDER</h2>
              <div class="single_h" v-for="time in get_contact_info.info.times" :key="time.id">
                <div class="icon">
                  <i class="bx bxs-time-five"></i>
                </div>
                <span>{{time.time}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "mapArea",
  data() {
    return {
      center: { lat: 0, lng: 0 },
    };
  },
  computed: {
    ...mapGetters({
      get_contact_info: "get_contact_info",
    }),
  },
  methods: {
    ...mapActions({
      contact_info_api: "contact_info_api",
    }),
    split_lang_lng() {
      console.log("lattude", this.get_contact_info);
      this.center.lat = this.get_contact_info.info.contact_location.latitude * 1;
      this.center.lng = this.get_contact_info.info.contact_location.longitude * 1;
    },
  },
  mounted() {
    this.contact_info_api().then(() => {
      this.split_lang_lng();
    });
  },
};
</script>
<style lang="scss" scoped>
.mapArea_section {
  padding-top: 70px;
  padding-bottom: 50px;
  background-image: url("~@/assets/what1.svg");
  background-position: bottom left;
  background-repeat: no-repeat;
  background-size: 36vw auto;
}
.contact_info {
  .box_ta {
    position: relative;
    padding-bottom: 15px;
    margin-bottom: 10px;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0px;
      width: 60px;
      height: 2px;
      background-color: var(--active_color);
    }
    h1 {
      line-height: 1.1;
      margin: 0;
      font-size: 2.5rem;
      font-family: "Oswald", sans-serif;
      text-transform: uppercase;
      font-weight: 700;
      color: white;
      margin-bottom: 25px;
    }
    a {
      display: block;
      color: #d8d8d8;
      margin-bottom: 4px;
      i {
        font-size: 20px;
        color: var(--active_color);
        vertical-align: middle;
      }
      .text {
        font-family: "Roboto", sans-serif;
        font-weight: 400;
        line-height: 30px;
        font-size: 16px;
        padding-left: 12px;
        display: inline-block;
      }
    }
  }
  .social_ta {
    display: flex;
    margin-top: 30px;
    margin-bottom: 20px;
    a {
      color: black;
      width: 30px;
      height: 30px;
      font-size: 20px;
      background-color: #ffff;
      margin-right: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;
    }
  }
  .open_ta {
    h2 {
      line-height: 1.6;
      margin: 0;
      font-size: 1.125rem;
      font-family: "Oswald", sans-serif;
      text-transform: uppercase;
      font-weight: 700;
      color: white;
      margin-top: 25px;
      margin-bottom: 5px;
    }
    .single_h {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 400;
      i {
        font-size: 20px;
        color: var(--active_color);
        vertical-align: middle;
      }
      span {
        font-family: "Roboto", sans-serif;
        font-weight: 400;
        line-height: 30px;
        font-size: 16px;
        padding-left: 12px;
        display: inline-block;
      }
    }
  }
}

@media(max-width:767px){
  .mapArea_section{
    padding-top: 30px;
  }
  .mapArea_section[data-v-b652fb8c] {
    background-position: bottom right;
    background-repeat: no-repeat;
    background-size: 25vw auto;
}
}
</style>
